import * as React from 'react'
import Joi from 'joi'
import { t } from 'i18next'
import { useDispatch } from '../../store'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormLabel,
  Grid,
  Stack,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material'
import { ArrowDropDown as SelectIcon } from '@mui/icons-material'
import { createRestriction } from '../../store/settings/actionCreator'
import { useNavigate } from 'react-router-dom'

type Props = {
  onClose: () => void
}

export const DialogAddRestrictions = ({ onClose }: Props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [type, setType] = React.useState('combined_phone')

  const handleTypeChange = (value: string) => {
    setType(value)
  }

  const handleSubmit = () => {
    console.log(type)
    const schema = Joi.string().valid('combined_phone').required()
    const { error } = schema.validate(type)

    if (error) {
      console.error('Validation error:', error.message)
      return
    }

    dispatch(createRestriction(type, navigate))
    
    console.log('Submitted type:', type)
    onClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open fullWidth onClose={handleClose}>
      <DialogTitle>{t('system.title')}</DialogTitle>

      <Divider variant="fullWidth" />

      <Stack spacing={2} sx={{ p: 3 }}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={5}>
            <FormLabel required>{t('system.select')}</FormLabel>
          </Grid>
          <Grid item xs={7}>
            <Select
              fullWidth
              value={type}
              IconComponent={SelectIcon}
              onChange={(e: SelectChangeEvent) => handleTypeChange(e.target.value)}
            >
              <MenuItem value="combined_phone">Phone\Advanced Phone</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Stack>

      <Divider variant="fullWidth" />

      <DialogActions sx={{ p: 2 }}>
        <Button size="large" color="primary" onClick={handleClose}>
          {t('common.close')}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
